import React from 'react';

import RecurringSessionIcon from '@/modules/events/components/RecurringSessionIcon';

import { useLearningContent } from '../context';
import { isRecurringSessionContent } from '../utils';

function RecurringEventIcon() {
  const { content } = useLearningContent();

  if (!isRecurringSessionContent(content.type)) {
    return null;
  }

  return <RecurringSessionIcon />;
}

export default React.memo(RecurringEventIcon);
